import { useTranslation } from "react-i18next";

const benefits = [
  { icon: "ri-links-line", key: "benefits.1" },
  { icon: "ri-user-star-line", key: "benefits.2" },
  { icon: "ri-refresh-line", key: "benefits.3" },
  { icon: "ri-book-open-line", key: "benefits.4" },
  { icon: "ri-shield-check-line", key: "benefits.5" },
  { icon: "ri-timer-flash-line", key: "benefits.6" },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: Benefits Grid */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-10">
              {t("benefits.title")}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((item) => (
                <div
                  key={item.key}
                  className="flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-default"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">
                    {t(item.key)}
                  </span>
                </div>
              ))}
            </div>

            {/* Social Proof */}
            <div className="mt-10 flex flex-wrap gap-6 md:gap-10">
              <div>
                <span className="block text-3xl font-bold text-primary-600 font-heading">10K+</span>
                <span className="text-xs text-foreground-500">Usuários Mensais</span>
              </div>
              <div>
                <span className="block text-3xl font-bold text-accent-600 font-heading">200+</span>
                <span className="text-xs text-foreground-500">Links Verificados</span>
              </div>
              <div>
                <span className="block text-3xl font-bold text-secondary-600 font-heading">Diária</span>
                <span className="text-xs text-foreground-500">Atualização</span>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20streetwear%20lifestyle%20photography%20young%20creative%20person%20in%20oversized%20charcoal%20crewneck%20sweatshirt%20and%20tailored%20trousers%20standing%20in%20sunlit%20minimalist%20loft%20exposed%20brick%20wall%20behind%20lush%20monstera%20plant%20in%20terracotta%20pot%20warm%20golden%20hour%20glow%20streaming%20through%20industrial%20windows%20relaxed%20natural%20pose%20with%20hands%20in%20pockets%20carefree%20modern%20aesthetic%20magazine%20quality%20European%20editorial%20style&width=800&height=600&seq=trust-lifestyle-v2-003&orientation=landscape"
                alt="CSSBuy Trust Lifestyle"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}